import { ref, onMounted, onBeforeUnmount } from 'vue'

export default {
  __name: 'PcSlideBanner',
  setup(__props) {

const onboarding = ref(1)

const dados = ref([
  {
    title: "Renove seu Certificado Digital",
    description:
      "Renovar o Certificado Digital é simples e pode ser feito 100% online garantindo praticidade e segurança na conclusão de suas transações.",
    img: "/images/img-slide-banner/img-banner-renovacao-pc.png",
    link: "https://wa.me/554192848223?text=Ol%C3%A1%2C%20gostaria%20de%20renovar%20meu%20certificado%20digital.",
    btn: "Renovar Agora",
  },
  {
    title: "Renove seu Certificado Digital SIPASS",
    description:
      "Você que já adquiriu o seu Certificado Digital no ano anterior. Aproveite as condições especiais para renovação.",
    img: "/images/img-slide-banner/img-banner-sispass-pc.png",
    link: "https://wa.me/554192848223?text=Ol%C3%A1%2C%20gostaria%20de%20renovar%20meu%20certificado%20digital.",
    btn: "Renovar Agora",
  },
  {
    title: "Condição especial para Produtor Rural",
    description:
      "Condição especial do Certificado Digital e-CNPJ a1 para emissão da nota fiscal do produtor rural",
    img: "/images/img-slide-banner/img-banner-produtor-pc.png",
    link: "../pages/e-cnpj",
    btn: "Comprar",
  },
]);

let intervalId = null;

onMounted(() => {
  intervalId = setInterval(() => {
    onboarding.value = onboarding.value >= dados.value.length ? 1 : onboarding.value + 1
  }, 20000)
});

onBeforeUnmount(() => {
  clearInterval(intervalId)
});

function next() {
  onboarding.value = onboarding.value + 1 > dados.value.length ? 1 : onboarding.value + 1
}

function prev() {
  onboarding.value = onboarding.value - 1 <= 0 ? dados.value.length : onboarding.value - 1
}

function openLink(link) {
  console.log('Opening link:', link);
  if (link) {
    window.open(link, '_blank')
  }
}

return { __sfc: true,onboarding, dados, intervalId, next, prev, openLink }
}

}